import { render } from "./footer.vue?vue&type=template&id=656411dd&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=656411dd&scoped=true&lang=css"

import exportComponent from "D:\\Code\\fuyou\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656411dd"]])

export default __exports__